import { Building2 } from 'lucide-react';
import { useBrand } from '@/branding/BrandContext';
import { useTranslation } from '@/lib/i18n';

export function TopBar() {
  const brand = useBrand();
  const { lang, setLang, t } = useTranslation();

  return (
    <header
      aria-label="Navigation principale"
      className="relative flex items-center justify-between px-4 py-3.5 border-b"
      style={{
        background: 'var(--brand-navy,#0A1128)',
        borderColor: 'rgba(255,255,255,0.05)',
      }}
    >
      <div
        aria-hidden="true"
        className="absolute left-0 right-0 top-0 h-[3px]"
        style={{
          background:
            'linear-gradient(90deg, var(--brand-primary,#22D3EE) 0%, var(--brand-blue-accent,#2D7FF9) 50%, var(--brand-primary,#22D3EE) 100%)',
        }}
      />
      <div className="flex items-center gap-2.5 text-white">
        <span
          className="w-9 h-9 rounded-lg flex items-center justify-center"
          style={{ background: 'rgba(255,255,255,0.08)' }}
          aria-hidden="true"
        >
          <Building2 size={18} strokeWidth={2} style={{ color: 'var(--brand-primary,#22D3EE)' }} />
        </span>
        <div>
          <div
            className="text-sm font-bold leading-tight"
            style={{ fontFamily: 'var(--brand-font-display)', letterSpacing: '-0.01em' }}
          >
            {brand.name}
          </div>
          <div className="text-[10px] mt-0.5" style={{ color: 'rgba(255,255,255,0.85)' }}>
            {brand.tagline}
          </div>
        </div>
      </div>

      <div
        role="group"
        aria-label="Language"
        className="flex rounded-full overflow-hidden"
        style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' }}
      >
        <button
          type="button"
          onClick={() => setLang('fr')}
          aria-pressed={lang === 'fr'}
          className="px-2.5 py-1 text-[10px] font-bold tracking-wider transition-colors"
          style={{
            background: lang === 'fr' ? 'var(--brand-primary,#22D3EE)' : 'transparent',
            color: lang === 'fr' ? 'var(--brand-navy,#0A1128)' : 'rgba(255,255,255,0.85)',
          }}
        >
          {t('topbar.lang_fr')}
        </button>
        <button
          type="button"
          onClick={() => setLang('en')}
          aria-pressed={lang === 'en'}
          className="px-2.5 py-1 text-[10px] font-bold tracking-wider transition-colors"
          style={{
            background: lang === 'en' ? 'var(--brand-primary,#22D3EE)' : 'transparent',
            color: lang === 'en' ? 'var(--brand-navy,#0A1128)' : 'rgba(255,255,255,0.85)',
          }}
        >
          {t('topbar.lang_en')}
        </button>
      </div>
    </header>
  );
}
